import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTransition } from '../../../contexts/TransitionContext';
import './PianoNavBar.css';

const PianoNavBar = () => {
  const navigate = useNavigate();
  const { goToHome, goToPosters } = useTransition();
  const audioContextRef = useRef(null);

  useEffect(() => {
    // Initialize AudioContext for sound generation
    audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
  }, []);

  const playNote = (frequency) => {
    if (!audioContextRef.current) return;
    
    const oscillator = audioContextRef.current.createOscillator();
    const gainNode = audioContextRef.current.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContextRef.current.destination);
    
    oscillator.frequency.setValueAtTime(frequency, audioContextRef.current.currentTime);
    oscillator.type = 'sine';
    
    gainNode.gain.setValueAtTime(0, audioContextRef.current.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.3, audioContextRef.current.currentTime + 0.01);
    gainNode.gain.exponentialRampToValueAtTime(0.001, audioContextRef.current.currentTime + 0.5);
    
    oscillator.start(audioContextRef.current.currentTime);
    oscillator.stop(audioContextRef.current.currentTime + 0.5);
  };

  const handleHomeClick = () => {
    playNote(261.63); // C4
    goToHome();
    navigate("/");
  };

  const handlePostersClick = () => {
    playNote(293.66); // D4
    goToPosters();
    navigate("/posters");
  };

  const handleBlogClick = () => {
    playNote(329.63); // E4
    navigate("/blog");
  };

  const handleAboutClick = () => {
    playNote(349.23); // F4
    navigate("/about");
  };

  const playBlackKeyNote = (frequency) => {
    playNote(frequency);
  };

  return (
    <nav className="piano-navbar">
      <div className="piano-keys">
        <button 
          className="white-key" 
          onClick={handleHomeClick}
          data-note="C"
        >
          <span className="key-label">Home</span>
        </button>
        
        <button 
          className="white-key" 
          onClick={handlePostersClick}
          data-note="D"
        >
          <span className="key-label">Posters</span>
        </button>
        
        <button 
          className="white-key" 
          onClick={handleBlogClick}
          data-note="E"
        >
          <span className="key-label">Blog</span>
        </button>
        
        <button 
          className="white-key" 
          onClick={handleAboutClick}
          data-note="F"
        >
          <span className="key-label">About</span>
        </button>
      </div>
    </nav>
  );
};

export default PianoNavBar;